import {Tooltip, Whisper} from "rsuite";

type FirmwareDescriptionCellProps = {
  description?: string | null;
};

const FirmwareDescriptionCell = ({description}: FirmwareDescriptionCellProps) => {
  const text = description?.trim() || "-";

  return (
    <Whisper
      placement="topStart"
      speaker={
        <Tooltip>
          <span className="firmwares-table__description-tooltip">{text}</span>
        </Tooltip>
      }
    >
      <span className="firmwares-table__description-cell">
        {text}
      </span>
    </Whisper>
  );
};

export default FirmwareDescriptionCell;
